import React, { FC } from "react";
import "./footer.css"
import "../../css/Main.css"




const Footer = () => {
    return (
        <div className="footer">
            <a className="link" target="_blank" href="https://github.com/obiwankenoobi">
                Built With <span>❤️</span>by <span className="me">@obiwankenoobi</span>
            </a>
        </div>
    );
  }
  
  export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js